<div class="container" *ngIf="showAlert" >
        <div id="message" >
            <div tyle="padding: 5px;">
                <div id="inner-message" class="alert alert-error">
                    <button type="button" class="close" (click)="close()" >&times;</button> {{CustomMessage}}
                </div>
            </div>
        </div>
    </div>